
import { api } from '../common/globals';
export const getObjectiveAvailabilityResponse = (user,begin, final,objective, step, slaOk, slaError, nodes) =>

        fetch(api+`/reporte/especial/specialMovistar/?user=${user}&begin=${begin}&final=${final}&data=${objective},${step},${slaOk},${slaError},true,false&type=normal&filter=false&time=&historic=true&insert=false`)
        .then(response => response.json())


export const getObjectiveAvailabilityResponseMonth = (user,begin, final,objective, step, slaOk, slaError) =>

        fetch(api+`/reporte/especial/specialMovistar/?user=${user}&begin=${begin}&final=${final}&data=${objective},${step},${slaOk},${slaError},true,false&type=normal&filter=false&time=&historic=true&insert=true`)
        .then(response => response.json())



// WEBPACK FOOTER //
// ./src/services/getObjectiveAvailabilityResponse.jsx